<template>
  <div>
    <div id="contact" v-show="!sent">
      <div id="left">
        <div id="name-email">
          <div id="name-wrapper">
            <input 
              v-validate="'required'"
              v-model="name"
              id="name"
              name="name"
              class="input"
              type="text"
              :placeholder="$t('contact.name')"
            />
            <span class="error" v-show="errors.has('name')">{{ errors.first('name') }}</span>
          </div>
          
          <div id="email-wrapper">
            <input 
              v-validate="'required|email'"
              v-model="email"
              name="email"
              id="email"
              class="input"
              type="text"
              :placeholder="$t('contact.email')" 
            />
            <span class="error" v-show="errors.has('email')">{{ errors.first('email') }}</span>
          </div>

        </div>
        <div id="subject-wrapper">
          <input
            v-validate="'required'"
            v-model="subject"
            name="subject"
            id="subject"
            class="input"
            type="text"
            :placeholder="$t('contact.subject')" />
          <span class="error" v-show="errors.has('subject')">{{ errors.first('subject') }}</span>
        </div>

        <div id="content-wrapper">
          <textarea
            v-validate="'required'"
            v-model="content"
            name="content"
            id="content"
            rows="8"
            class="textarea"
            type="text"
            :placeholder="$t('contact.content')" />
          <span class="error" v-show="errors.has('content')">{{ errors.first('content') }}</span>
        </div>

        <div id="button-wrapper">
          <button @click="send" :class="['button', sending ? 'is-loading': '']">{{ $t('contact.send') }}</button>
        </div>

        <a href="tel:70839436" id="phone" class="mobile">
          <div id="phone-image"/>
            <span>7083 9436 (Whatsapp)</span>
        </a>
        <a :href="`mailto:${contactEmail}`" id="contact-email" class="mobile" @click="onContactEmail">
          <div id="email-image" />
          <span>{{ contactEmail }}</span>
        </a>

      </div>
      <div id="right">
        <div id="contact-us-title">{{ $t('tabBar.contactUs') }}</div>
        <div id="more-detail">
          {{ $t('contact.moreDetail1') }}<br>{{ $t('contact.moreDetail2') }}
        </div>
        <a href="https://wa.me/85270839436" id="phone" class="desktop" @click="onPhone">
          <div id="phone-image"/>
            <span>7083 9436 (Whatsapp)</span>
        </a>
        <a :href="`mailto:${contactEmail}`" id="contact-email" class="desktop">
          <div id="email-image" />
            <span>{{ contactEmail }}</span>
        </a>
      </div>
    </div>
    <div id="sent-message" v-show="sent">
      <i class="fa fa-check-circle" aria-hidden="true"></i><br>
      郵件已經發送，我們會盡快回覆你
    </div>

  </div>
</template>

<script>
import createEmail from '../models/Email';

export default {
  name: 'Contact',
  data() {
    return {
      name: null,
      email: null,
      subject: null,
      content: null,
      sending: false,
      sent: false,
      contactEmail: 'info@dramaaction.net',
    };
  },
  methods: {
    send() {
      this.$validator.validateAll();
      if (this.errors.any()) {
        return;
      }
      this.sending = true;
      createEmail(this.name, this.email, this.subject, this.content).then(() => {
        this.sending = false;
        this.name = null;
        this.email = null;
        this.subject = null;
        this.content = null;
        this.$validator.clean();
        this.sent = true;
      });
    },
    onContactEmail() {
      window.gtag('event', 'conversion', {
        send_to: 'AW-823717499/WaG1CIXh5oMYEPvc44gD',
      });
    },
    onPhone() {
      window.gtag('event', 'conversion', {
        send_to: 'AW-823717499/HlNrCJTNr6UDEPvc44gD',
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "../styles/variables.sass"

  #contact
    max-width: 891px
    margin: 60px auto
    display: flex
    padding-left: 65px
    padding-right: 65px

    @media #{$mobile}
      flex-direction: column-reverse
      justify-content: center
      margin-top: 30px
      margin-bottom: 30px
      padding-left: 30px
      padding-right: 30px

  #left
    flex-grow: 1
    flex-shrink: 1

  #right
    flex-shrink: 0
    @media #{$desktop}
      margin-left: 40px
      text-align: right

  #name-email
    display: flex
    margin-bottom: 18px
    @media #{$mobile}
      flex-wrap: wrap

  #name-wrapper
    flex-shrink: 294
    @media #{$desktop}
      flex: 2

    @media #{$mobile}
      margin-bottom: 18px
      width: 100%

  #email-wrapper
    flex-shrink: 186
    @media #{$desktop}
      margin-left: 10px
      flex: 3
    @media #{$mobile}
      width: 100%

  #content-wrapper
    margin-bottom: 30px

  #subject-wrapper
    margin-bottom: 18px

  #button-wrapper
    @media #{$desktop}
      display: flex
      justify-content: flex-end
    @media #{$mobile}
      margin-bottom: 55px

  .button
    background: $macaroni-and-cheese
    border-radius: 5px
    color: $white
    height: 43px
    font-size: 20px
    display: block
    width: 100%

    @media #{$desktop}
      width: 155px

  #contact-us-title
    color: $jaffa
    font-size: 30px
    margin-bottom: 12px
    @media #{$mobile}
      font-size: 24px
      text-align: center
      margin-bottom: 20px

  #more-detail
    color: $rajah
    font-size: 18px
    margin-bottom: 80px
    @media #{$mobile}
      font-size: 16px
      margin-bottom: 12px
      text-align: center

  #phone
    display: block
    font-size: 20px
    color: $froly
    margin-bottom: 24px
    span
      vertical-align: middle
      margin-left: 2px

    @media #{$mobile}
      font-size: 16px
      margin-bottom: 16px

  #phone-image
    background-image: url('../../static/mobile-icon.png')
    width: 30px
    height: 31px
    background-position: center
    background-size: 19px 31px
    background-repeat: no-repeat
    display: inline-block
    vertical-align: middle

  #contact-email
    display: block
    font-size: 16px
    color: $froly
    span
      vertical-align: middle
      margin-left: 2px

  #email-image
    background-image: url('../../static/email-icon.png')
    width: 30px
    height: 30px
    background-position: center
    background-repeat: no-repeat
    background-size: 29px 19px
    display: inline-block
    vertical-align: middle

  input, textarea
    &::-webkit-input-placeholder
      color: $dusty-gray
    &::-moz-placeholder
      color: $dusty-gray
    &:-ms-input-placeholder
      color: $dusty-gray
    &:-moz-placeholder
      color: $dusty-gray

  .error
    font-size: 12px
    color: $froly

  #sent-message
    .fa
      font-size: 70px
      margin-bottom: 20px
    text-align: center
    font-size: 18px
    margin-top: 60px
    color: $atomic-tangerine

</style>



// WEBPACK FOOTER //
// src/components/Contact.vue